
import EDList from '../../../../../../../../../../BaseComponents/List/EDList';
import {
  ISumCategory,
  ISumData,
} from '../../../../../Queries/EkonomiskAnalysSettingsQuery/EkonomiskAnalysSettingsQuery';
import SummeringListItem from '../SummeringListItem/SummeringListItem';
import { withStyles } from 'tss-react/mui';
import EDFormGroup from '../../../../../../../../../../BaseComponents/FormGroup/EDFormGroup';

interface IProps {
  availableCategories: ISumCategory[];
  selectedSums: ISumData[];
  toggleSelectedSum: (selected: boolean, choise: ISumData) => void;
  classes?: any;
}

const styles = () => ({
  flexContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: 8,
  },
  subcontainer: {
    width: 'calc(33% - 16px)',
    minWidth: '12rem',
    maxWidth: '14rem',
    flex: '1 1 auto',
    marginBottom: '1rem',
    padding: '0 8px',
    '&:last-of-type': {
      flex: '2 1 auto',
    },
  },
});

const EkonomiskAnalysSummeringList = (props: IProps) => {
  return (
    <EDList dense>
      {props.availableCategories.map(category => (
        <EDFormGroup
          key={category.code}
          label={category.name}
          line
          size="small"
        >
          <div className={props.classes.flexContainer}>
            {category.subCategories.map(subCategory => (
              <div
                key={subCategory.code}
                className={props.classes.subcontainer}
              >
                {subCategory.sums.map((sum, index) => {
                  const listIndex = props.selectedSums.findIndex(
                    selectedSum => selectedSum.Namn === sum.Namn
                  );
                  return (
                    <SummeringListItem
                      key={`${subCategory.code} ${index}`}
                      toggleSelectedSum={props.toggleSelectedSum}
                      sum={sum}
                      checked={listIndex !== -1}
                      index={listIndex}
                    />
                  );
                })}
              </div>
            ))}
          </div>
        </EDFormGroup>
      ))}
    </EDList>
  );
};

export default withStyles(EkonomiskAnalysSummeringList, styles);
